import { makeStyles } from 'tss-react/mui';

export const AgencyPageStyle = makeStyles()({
    firstHeaderStyle: {
        backgroundColor: "darkgray !important"
    },

    tableContainerItem: {
        flex: 1,
        minHeight: 0,
        width: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
    },

    dashboardPageMainContainer: {
        background: "#fff",
        padding: "25px",
        borderRadius: "10px",
        height: "100%",
        minHeight: 0,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        overflow: "hidden",
    },

    tableCellwithoutBorder: {
        wordBreak: "break-word",
        borderRight: "0px !important"
    },

    tableCellwithBorder: {
        wordBreak: "break-word"
    },
    evenRow: {

    },
    oddRow: {

    },
    lastRow: {
        'td': {
            backgroundColor: '#3B78CE26 !important',
        },
        'td:first-child': {
            zIndex: 1000
        }
    },
    filterIconItem: {
        display: "flex",
        marginLeft: "15px",
    },
    filterButton: {
        borderRadius: "5px",
        padding: "5px",
        cursor: "pointer",
        border: "none",
    },
    filterTitle: {
        color: "#3B78CE",
        fontWeight: 600,
        padding: "15px 0px 5px 16px"
    },
    buttonItem: {
        padding: "5px 0px 15px 16px",
        'button': {
            padding: "4px 17px"
        }
    }
})


